<button mat-icon-button type="button" aria-label="{{'Lukk panel'|translate}}">
  <mat-icon>right_panel_close</mat-icon>
</button>
